"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SysLangPicker = void 0;
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useStaffFindById_1 = __importDefault(require("@opsbase/react-gql-hooks/staff/useStaffFindById"));
const LanguagePicker_1 = __importDefault(require("@opsbase/web-pickers/LanguagePicker"));
const react_1 = __importStar(require("react"));
const useSysLang_1 = __importDefault(require("../SysLangController/useSysLang"));
const SysLangPicker = () => {
    var _a;
    const { language, setLanguage } = (0, useSysLang_1.default)();
    const self = (0, useSelf_1.default)();
    const allowed = self.settings.languages;
    const { data: staff } = (0, useStaffFindById_1.default)({ variables: { id: self === null || self === void 0 ? void 0 : self.id } });
    const alreadySetPreferredLanguage = (0, react_1.useRef)(false);
    const preferredLanguage = (_a = staff === null || staff === void 0 ? void 0 : staff.preferences) === null || _a === void 0 ? void 0 : _a.language;
    (0, react_1.useEffect)(() => {
        if (!alreadySetPreferredLanguage.current && language !== preferredLanguage) {
            setLanguage(preferredLanguage);
        }
        if (preferredLanguage)
            alreadySetPreferredLanguage.current = true;
    }, [language, setLanguage, preferredLanguage]);
    const handleChangeLanguage = (0, react_1.useCallback)(l => setLanguage(l), [setLanguage]);
    const picker = (0, react_1.useMemo)(() => (react_1.default.createElement(LanguagePicker_1.default, { flagOnly: true, noMargin: true, noBorder: true, white: true, allowed: allowed, value: language, onChange: handleChangeLanguage })), [handleChangeLanguage, allowed, language]);
    if (!staff)
        return null;
    return picker;
};
exports.SysLangPicker = SysLangPicker;
exports.default = exports.SysLangPicker;
